import {
  FACEBOOK as FACEBOOK_CONSTANT,
  INSTAGRAM as INSTAGRAM_CONSTANT,
  TIKTOK as TIKTOK_CONSTANT,
  YOUTUBE as YOUTUBE_CONSTANT,
  LINKEDIN as LINKEDIN_CONSTANT,
} from "../../../../utils/constants";
import FacebookPlatformFields from "../components/platforms/FacebookPlatformFields";
import InstagramPlatformFields from "../components/platforms/InstagramPlatformFields";
import TikTokPlatformFields from "../components/platforms/TikTokPlatformFields";
import YouTubePlatformFields from "../components/platforms/YouTubePlatformFields";
import LinkedInPlatformFields from "../components/platforms/LinkedInPlatformFields";

export const BASE_PLATFORM_DEFAULTS = {
  [FACEBOOK_CONSTANT]: {
    account: null,
    contentType: "",
  },
  [INSTAGRAM_CONSTANT]: {
    account: null,
    contentType: "",
    collaborators: [],
  },
  [TIKTOK_CONSTANT]: {
    account: null,
    privacy_level: "",
    disable_duet: false,
    disable_stitch: false,
    disable_comment: false,
    is_aigc: false,
    auto_add_music: false,
  },
  [YOUTUBE_CONSTANT]: {
    account: null,
    title: "",
    privacyStatus: "",
    notifySubscribers: false,
    madeForKids: false,
  },
  [LINKEDIN_CONSTANT]: {
    account: null,
  },
};

export const createPlatformDefaultValues = () =>
  Object.entries(BASE_PLATFORM_DEFAULTS).reduce((acc, [key, value]) => {
    acc[key] = { ...value };
    return acc;
  }, {});

export const PLATFORM_FIELD_GROUPS = {
  [FACEBOOK_CONSTANT]: [
    "platformsData.facebook.account",
    "platformsData.facebook.contentType",
  ],
  [INSTAGRAM_CONSTANT]: [
    "platformsData.instagram.account",
    "platformsData.instagram.contentType",
    "platformsData.instagram.collaborators",
  ],
  [TIKTOK_CONSTANT]: [
    "platformsData.tiktok.account",
    "platformsData.tiktok.privacy_level",
    "platformsData.tiktok.disable_duet",
    "platformsData.tiktok.disable_stitch",
    "platformsData.tiktok.disable_comment",
    "platformsData.tiktok.is_aigc",
    "platformsData.tiktok.auto_add_music",
  ],
  [YOUTUBE_CONSTANT]: [
    "platformsData.youtube.account",
    "platformsData.youtube.title",
    "platformsData.youtube.privacyStatus",
    "platformsData.youtube.notifySubscribers",
    "platformsData.youtube.madeForKids",
  ],
  [LINKEDIN_CONSTANT]: ["platformsData.linkedIn.account"],
};

export const PLATFORM_FORM_COMPONENTS = {
  [FACEBOOK_CONSTANT]: FacebookPlatformFields,
  [INSTAGRAM_CONSTANT]: InstagramPlatformFields,
  [TIKTOK_CONSTANT]: TikTokPlatformFields,
  [YOUTUBE_CONSTANT]: YouTubePlatformFields,
  [LINKEDIN_CONSTANT]: LinkedInPlatformFields,
};
